module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-footer teal",
    attrs: {
      "id": "sobre"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('h5', {
    staticClass: "white-text left"
  }, [_vm._v("More about me...")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "grey-text text-lighten-4"
  }, [_vm._v("\n                " + _vm._s(_vm.info) + "            \n            ")])])]), _vm._v(" "), _c('a', {
    staticClass: "scrollSuave",
    attrs: {
      "href": "#topo"
    }
  }, [_c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('span', {
    staticClass: "grey-text text-lighten-4 "
  }, [_vm._v("© " + _vm._s(_vm.yearUpdate) + " - juscilan.com   ")]), _vm._v(" "), _c('span', {
    staticClass: "grey-text text-lighten-4 "
  }, [_vm._v("Version " + _vm._s(_vm.version) + " ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c56bb57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jm-i-footer.vue
// module id = 414
// module chunks = 1